import {
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_RESET,
  USER_DETAILS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_RESET,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_LIST_SUCCESS,
  CONFIRM_USER_REQUEST,
  CONFIRM_USER_SUCCESS,
  CONFIRM_USER_FAIL,
} from "../Constants/UserConstants";

// LOGIN
export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// REGISTER
export const userRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_REGISTER_REQUEST:
      return { loading: true };
    case USER_REGISTER_SUCCESS:
      return {
        loading: false,
        success: true,
        userRegisterInfo: action.payload,
      };
    case USER_REGISTER_FAIL:
      return { loading: false, success: false, error: action.payload };
    case USER_REGISTER_RESET:
      return {};
    default:
      return state;
  }
};

// USER DETAILS
export const userDetailsReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case USER_DETAILS_REQUEST:
      return { ...state, loading: true };
    case USER_DETAILS_SUCCESS:
      return { loading: false, user: action.payload };
    case USER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case USER_DETAILS_RESET:
      return { user: {} };
    default:
      return state;
  }
};

// UPDATE PROFILE
export const userUpdateProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_UPDATE_PROFILE_REQUEST:
      return { loading: true };
    case USER_UPDATE_PROFILE_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case USER_UPDATE_PROFILE_FAIL:
      return { loading: false, success: false, error: action.payload };
    default:
      return state;
  }
};

export const userListReducer = (
  state = { loading: false, recordItems: [] },
  action
) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
    case USER_LIST_RESET:
      return { loading: true, recordItems: [] };
    case USER_LIST_SUCCESS:
      return {
        loading: false,
        recordItems: action.payload.items,
        nextStartKey: action.payload.paginationToken,
      };
    case `USER_LIST_FAIL`:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userConfirmReducer = (state = {}, action) => {
  switch (action.type) {
    case CONFIRM_USER_REQUEST:
      return { loading: true };
    case CONFIRM_USER_SUCCESS:
      return { loading: false, confirmUserInfo: action.payload };
    case CONFIRM_USER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
